import React, { BaseSyntheticEvent, FC } from "react";
import { CloseButton } from "react-bootstrap";
import { useTranslation } from "react-i18next";

export enum ConfirmModalVariants {
  PRIMARY = "primary",
  SECONDARY = "secondary",
}

type Props = {
  variant?: ConfirmModalVariants;
  title: string;
  description: string;
  confirmText: string;
  show: boolean;
  onConfirm: any;
  onCancel?: any;
};

export const ConfirmModal: FC<Props> = ({
  title,
  description,
  confirmText,
  show,
  onConfirm,
  onCancel,
  variant = ConfirmModalVariants.PRIMARY,
}) => {
  const { t } = useTranslation();

  const closeByBackground = (e: BaseSyntheticEvent) => {
    e.stopPropagation();
    if (e.target.id === "confirmModal") onCancel();
  };

  const getButtonPanel = (variant: ConfirmModalVariants) => {
    switch (variant) {
      case ConfirmModalVariants.PRIMARY:
        return (
          <div className="py-3 px-4 border-0 d-flex justify-content-between flex-nowrap">
            <button
              type="button"
              className="white-hover btn btn-outline-danger danger-hover text-danger col-6"
              onClick={onConfirm}
            >
              {confirmText}
            </button>
            <button
              type="button"
              className="btn btn-primary ms-2 text-white col-6"
              onClick={onCancel}
            >
              {t("profile.cancel")}
            </button>
          </div>
        );
      case ConfirmModalVariants.SECONDARY:
        return (
          <div className="py-3 px-4 border-0 d-flex justify-content-between flex-nowrap">
            <button
              type="button"
              className="btn btn-outline-dark dark-hover text-dark-gray col-6"
              onClick={onCancel}
            >
              {t("profile.cancel")}
            </button>
            <button
              type="button"
              className="white-hover btn btn-primary text-white col-6 ms-2"
              onClick={onConfirm}
            >
              {confirmText}
            </button>
          </div>
        );
    }
  };

  return (
    <div
      id="confirmModal"
      className={`modal ${show ? "show d-flex" : ""} align-items-center justify-content-center`}
      style={{
        display: show ? "block" : "none",
        background: "rgb(0, 0, 0, 0.6)",
      }}
      onClick={(e) => closeByBackground(e)}
    >
      <div className="modal-dialog">
        <div className="modal-content text-break">
          <div className="modal-header border-0 d-flex justify-content-between">
            <h5 className="modal-title fw-700 fs-3">{title}</h5>
            <CloseButton
              onClick={onCancel}
              style={{ height: "16px", width: "16px", opacity: "1" }}
            />
          </div>
          <div className="modal-body border-0 text-center px-5">
            {description}
          </div>
          {getButtonPanel(variant)}
        </div>
      </div>
    </div>
  );
};
